/**
 * @file 答题页store
 */
import Vue from 'vue';
import Vuex from 'vuex';
import server from '@/pages/pano-game/service';
import Const from '@/pages/pano-game/constant/Constant';

Vue.use(Vuex);

const state = {
    panoGameMode: '',
    // 数据加载状态
    panoDataErr: false,
    // 数据加载错误码
    panoDataErrCode: 0,
    // 数据加载错误信息
    panoDataErrMsg: '',
    // 数据加载状态
    panoDataLoading: false,
    // 最后一次弹窗码，暂时只能是错误复活弹窗
    lastDialogNum: 0,
    // 问题基础信息
    questionData: {},
    // 答题的列表
    answerList: [],
    // 答题关数
    questionNum: 1,
    // 答题总关数
    totalTopicNum: Const.defaultTopicNum,
    // 挑战者
    challenge: '0',
    // 幸存者
    survivor: '0',
    // 打败人数
    beatNum: '0',
    // 答题总时间
    answerTime: Const.defaultEscapeCountDown,
    // 剩余时间
    surplusTime: Const.defaultEscapeCountDown,
    // 设置是否超时
    overtime: false,
    // 设置游戏状态 0:进行中 1：成功 2：失败
    gameStatus: Const.gameStatus.doing,
    // 问题的 pid
    questionPid: '',
    questionUid: '',
    questionCityName: '', // 当前答对的题的城市
    // 是否有助力等待是否超时
    // 复活方式默认为空 没有使用任何复活方式， free 免费复活  coins 金币复活 assist 助力复活  overtime 助力超时 noTimeOut 没有超时
    revivedMode: '', //  ''代表没有助力
    wrongCity: '', // 回答过的错误答案
    // 正确答案
    rightCityName: '',
    // 设置中奖的金额
    prizeCashNum: '',
    // 闯关模式的困难程度
    isHard: 0,
    // 闯关模式的当前关卡
    level: 1,
    // 首次通关标识
    firstPlay: 0
};

const mutations = {
    // 设置答题类型
    setPanoGameMode(state, data) {
        state.panoGameMode = data;
    },
    // 设置闯关模式的当前关卡
    setLevel(state, data) {
        state.level = Number(data);
    },
    // 设置首次通关标识
    setFirstPlay(state, data) {
        state.firstPlay = data;
    },
    // 设置答题类型
    setLastDialogNum(state, data) {
        state.lastDialogNum = data;
    },
    // 设置数据加载
    setPanoDataErr(state, data) {
        state.panoDataErr = data;
    },
    // 设置数据加载错误信息
    setPanoDataErrCode(state, data) {
        state.panoDataErrCode = data.errno || 0;
        state.panoDataErrMsg = data.errstr || '';
    },
    // 设置数据加载
    setPanoDataLoading(state, data) {
        state.panoDataLoading = data;
    },
    // 设置是否超时
    setOvertime(state, data) {
        state.overtime = data;
    },
    // 设置游戏状态
    setGameStatus(state, data) {
        state.gameStatus = data;
    },
    // 设置问题基础信息
    setQuestionData(state, data) {
        // 问题基础信息
        state.questionData = data;
        // 获取题目是清空标识
        state.firstPlay = 0;
        state.gameStatus = Const.gameStatus.doing;
        // 设置答题的 uid
        state.questionUid = data.uid;
        state.revivedMode = data.revivedMode;
        state.wrongCity = data.wrongCity;
        // 设置答题的 pid
        state.questionPid = data.pid;
        // 设置答题的选项数组
        state.answerList = data.answerList;
        // 答到第几题了
        state.questionNum = data.topicNum;
        // 总共有几道题
        state.totalTopicNum = data.totalTopicNum;
        // 答题总时间
        state.answerTime = data.answerTime || Const.defaultEscapeCountDown;
        // 剩余时间
        state.surplusTime = data.surplusTime || 0;
        // 设置正确城市
        state.rightCityName = data.rightCityName;

        if (state.panoGameMode === Const.gameMode.escape) {
            state.challenge = String(Math.floor(Number(data.challenge || 0)));
            state.survivor = String(Math.floor(Number(data.survivor || 0)));
            if (data.beatNum) {
                state.beatNum = String(Math.floor(data.beatNum || 0));
            }
            else {
                state.beatNum = String(Math.floor(data.challenge - data.survivor));
            }
        }
        else if (state.panoGameMode === Const.gameMode.kingRoad) {
            state.isHard = Number(data.levelType) === Const.levelTypes.hard;
        }
        else {
            state.challenge = '0';
            state.survivor = '0';
            state.beatNum = '0';
        }
        // 设置是否超时
        if (
            state.panoGameMode === Const.gameMode.escape
          || (state.panoGameMode === Const.gameMode.kingRoad && state.isHard)
        ) {
            state.overtime = state.surplusTime <= 0;
        }
        else {
            state.overtime = false;
        }
    },
    // 设置答题的 pid
    setQuestionPid(state, data) {
        state.questionPid = data;
    },
    // 设置答题的 uid
    setQuestionUid(state, data) {
        state.questionUid = data.uid;
        state.revivedMode = data.revivedMode;
        state.wrongCity = data.wrongCity;
    },
    // 设置答题的选项数组
    setAnswerList(state, data) {
        state.answerList = data;
    },
    // 答到第几题了
    setQuestionNum(state, data) {
        state.questionNum = data;
    },
    setAnswerInfo(state, data) {
        state.questionCityName = data.rightName;
        state.survivor = String(Math.floor(Number(data.survivorNum || 0)));
        state.beatNum = String(Math.floor(Number(data.beatNum || 0)));
        // 判断游戏通关状态
        if (data.answerResult) {
            if (state.totalTopicNum === state.questionNum) {
                state.gameStatus = Const.gameStatus.pass;
            }
            else {
                state.gameStatus = Const.gameStatus.doing;
            }
        }
        else {
            state.gameStatus = Const.gameStatus.fail;
        }
    },
    setRightCity(state, data) {
        state.rightCityName = data;
    },
    // 设置中奖的金额
    setCashNum(state, data) {
        state.prizeCashNum = data;
    }
};
const getters = {
};
const actions = {
    // 全景答题页部分
    getQuestion: ({commit, state, rootState}, params = {}) => {
        const reqParams = {
            type: state.panoGameMode
        };
        if (reqParams.type === Const.gameMode.escape) {
            reqParams.mn = rootState.escape.matchMaxNum;
        }
        // 王者之路，进入对应关卡
        else if (reqParams.type === Const.gameMode.kingRoad) {
            reqParams.level = (params && params.level) || state.level;
        }
        commit('setPanoDataErr', false);
        commit('setPanoDataErrCode', {});
        commit('setPanoDataLoading', true);
        return server('getQuestion', reqParams)
            .then(res => {
                commit('setPanoDataLoading', false);
                commit('setPanoDataErr', false);
                if (res && res.errno === 0 && res.data) {
                    window.pano.setId(res.data.pid);
                    commit('setQuestionData', res.data);
                    if (res.data.prizeInfo && res.data.prizeInfo.lotteryResult === 1) {
                        commit('setCashNum', res.data.prizeInfo.prizeInfo.cash);
                    }
                    else {
                        commit('setCashNum', '');
                    }
                    return res.data.pid;
                }
                if (res && res.errno) {
                    commit('setPanoDataErrCode', res);
                    throw new Error(res.errstr || '获取题目失败');
                }
                throw new Error('获取题目失败');
            }).catch(err => {
                commit('setPanoDataErr', true);
                commit('setPanoDataLoading', false);
                throw err;
            });

    },

    // 获得答案
    getAnswer: ({commit, state, rootState}, param) => {
        const reqParams = {
            ...param,
            type: state.panoGameMode
        };
        if (reqParams.type === Const.gameMode.escape) {
            reqParams.mn = rootState.escape.matchMaxNum;
        }
        return server('getAnswer', reqParams).then(res => {
            if (res && res.errno === 0) {
                // 1是答对，0是答错
                if (Number(res.data.answerResult) === 1) {
                    commit('setAnswerInfo', res.data);
                    // 原有判断逻辑，胜利给红包
                    if (res.data.prizeInfo && res.data.prizeInfo.lotteryResult === 1) {
                        commit('setCashNum', res.data.prizeInfo.prizeInfo.cash);
                    }
                    else {
                        commit('setCashNum', '');
                    }
                }
            }
            return res;
        });
    },
    // 复活接口
    backToLife: ({commit, rootState}, param) => {
        return server('resurrection', param).then(res => {
            if (res && res.errno === 0 && res.data) {
                if (rootState.isEscape || rootState.isKingRoad) {
                    commit('setFirstPlay', res.data.firstPlay);
                }
                return res.data;
            }
            throw new Error(res.errstr || '复活失败');
        });
    },
    // 通关页接口
    getPassData: ({commit, state, rootState}) => {
        const reqParams = {
            type: state.panoGameMode
        };
        if (reqParams.type === Const.gameMode.kingRoad) {
            if (state.firstPlay) {
                reqParams.firstPlay = state.firstPlay;
            }
            reqParams.level = state.level;
        }
        else if (reqParams.type === Const.gameMode.escape) {
            reqParams.mn = rootState.escape.matchMaxNum;
        }
        return server('passData', reqParams);
    },
    // 放弃接口
    quitGame: ({commit, state, rootState}) => {
        const reqParams = {
            type: state.panoGameMode
        };
        if (reqParams.type === Const.gameMode.escape) {
            reqParams.mn = rootState.escape.matchMaxNum;
        }
        return server('giveUp', reqParams)
            .then(res => {
                if (res && res.errno === 0) {
                    commit('setGameStatus', Const.gameStatus.fail);
                }
                else {
                    throw new Error(res.errstr || '');
                }
            });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
